import {Types} from 'mongoose';
import * as dis2 from '../../dispossitions/dispossition-conflict-resolutions.const';
import {ACTIVITY_TYPE_CONFLICT_RESOLUTION, ACTIVITY_TYPE_CONFLICT_RESOLUTION_ID} from '../activity-type.const';
import {FACILITATION_FEE, FC_KEEPER_PAYMENT, MEDIATOR_PAYMENT, OTHER_FEE, SESSION_FEE} from '../payamnets.data';
import {
    ACTIVITY_SUBTYPE_CONCILIATION_ID,
    ACTIVITY_SUBTYPE_CONFLICT_COACHING_ID,
    ACTIVITY_SUBTYPE_DELIBERATIVE_DIALOGUES,
    ACTIVITY_SUBTYPE_DELIBERATIVE_DIALOGUES_ID,
    ACTIVITY_SUBTYPE_FACILITATION_ID,
    ACTIVITY_SUBTYPE_MEDIATION,
    ACTIVITY_SUBTYPE_MEDIATION_ID,
    ACTIVITY_SUBTYPE_OTHER_ID,
    ACTIVITY_SUBTYPE_RESTOTATIVE_PRACTICES_ID,
} from './conflict-resolution.consts';

export const MEDIATION = {
    _id: new Types.ObjectId(ACTIVITY_SUBTYPE_MEDIATION_ID),
    label: ACTIVITY_SUBTYPE_MEDIATION,
    defaultDisposition: dis2.CR_ME_OPEN_PENDING,
    dispositions: [
        dis2.CR_ME_OPEN_PENDING,
        dis2.CR_ME_FULL_AGREEMENT,
        dis2.CR_ME_NO_AGREEMENT,
        dis2.CR_ME_PARTIAL_AGREEMENT,
        dis2.CR_ME_NO_CONTACT,
        dis2.CR_ME_TOO_FEW_PARTIES,
        dis2.CR_ME_CANCELED_NO_SHOW,
        dis2.CR_ME_DECLINED,
        dis2.CR_ME_WITHDRAWN,
        dis2.CR_ME_DISCONTINUED,
        dis2.CR_ME_INAPPROPRIATE,
        dis2.CR_ME_LIMITED_RESOURCES_MEDIATOR,
        dis2.CR_ME_LIMITED_RESOURCES_INTERPRETER,
        dis2.CR_ME_LIMITED_RESOURCES_TECHNOLOGY,
        dis2.CR_ME_LIMITED_RESOURCES_SPACE,
        dis2.CR_ME_LIMITED_RESOURCES_OTHER,
    ],
    paymentIn: [SESSION_FEE, OTHER_FEE],
    paymentOut: [OTHER_FEE, MEDIATOR_PAYMENT, FC_KEEPER_PAYMENT],
};

export const CONCILATION = {
    _id: new Types.ObjectId(ACTIVITY_SUBTYPE_CONCILIATION_ID),
    label: 'Conciliation',
    defaultDisposition: dis2.CR_CO_OPEN_PENDING,
    dispositions: [
        dis2.CR_CO_OPEN_PENDING,
        dis2.CR_CO_FULL_AGREEMENT,
        dis2.CR_CO_NO_AGREEMENT,
        dis2.CR_CO_PARTIAL_AGREEMENT,
        dis2.CR_CO_NO_CONTACT,
        dis2.CR_CO_TOO_FEW_PARTIES,
        dis2.CR_CO_CANCELLED_NO_SHOW,
        dis2.CR_CO_DECLINED,
        dis2.CR_CO_WITHDRAWN,
        dis2.CR_CO_DISCONTINUED,
        dis2.CR_CO_INAPPROPRIATE,
        dis2.CR_CO_LIMITED_RESOURCES_CONCILATOR,
        dis2.CR_CO_LIMITED_RESOURCES_INTERPRETER,
        dis2.CR_CO_LIMITED_RESOURCES_TECHNOLOGY,
        dis2.CR_CO_LIMITED_RESOURCES_SPACE,
        dis2.CR_CO_LIMITED_RESOURCES_OTHER,
    ],
    paymentIn: [SESSION_FEE, OTHER_FEE],
    paymentOut: [OTHER_FEE, MEDIATOR_PAYMENT, FC_KEEPER_PAYMENT],
};

export const FACILITATION = {
    _id: new Types.ObjectId(ACTIVITY_SUBTYPE_FACILITATION_ID),
    label: 'Facilitation',
    defaultDisposition: dis2.CR_FA_OPEN_PENDING,
    dispositions: [
        dis2.CR_FA_OPEN_PENDING,
        dis2.CR_FA_COMPLETED,
        dis2.CR_FA_WITHDRAWN_DISCONTINUED_BEFORE_A_FASCILITATION_SESSION,
        dis2.CR_FA_WITHDRAWN_DISCONTINUED_AFTER_ONE_OR_MORE_FASCILITATION_SESSION,
    ],
    paymentIn: [SESSION_FEE, FACILITATION_FEE, OTHER_FEE],
    paymentOut: [OTHER_FEE, MEDIATOR_PAYMENT, FC_KEEPER_PAYMENT],
};

export const CONFLICT_COACHING = {
    _id: new Types.ObjectId(ACTIVITY_SUBTYPE_CONFLICT_COACHING_ID),
    label: 'Conflict Coaching',
    defaultDisposition: dis2.CR_CC_OPEN_PENDING,
    dispositions: [
        dis2.CR_CC_OPEN_PENDING,
        dis2.CR_CC_COMPLETED,
        dis2.CR_CC_WITHDRAWN_BEFORE_CONFLICT_COACHING_SESSION,
        dis2.CR_CC_WITHDRAWN_AFTER_ONE_OR_MORE_CONFLICT_COACHING_SESSION,
    ],
    paymentIn: [SESSION_FEE, OTHER_FEE],
    paymentOut: [OTHER_FEE, MEDIATOR_PAYMENT, FC_KEEPER_PAYMENT],
};

export const RESTORATIVE_PRACTICES = {
    _id: new Types.ObjectId(ACTIVITY_SUBTYPE_RESTOTATIVE_PRACTICES_ID),
    label: 'Restorative Practices',
    dispositions: [
        dis2.CR_RPC_OPEN_PENDING,
        dis2.CR_RPC_COMPLETED,
        dis2.CR_RPC_AGREEMENT,
        dis2.CR_RPC_NO_AGREEMENT,
        dis2.CR_RPC_PARTIAL_AGREEMENT,
        dis2.CR_RPC_WITHDRAWN_BEFORE_RESTORATIVE_CIRCLE,
        dis2.CR_RPC_WITHDRAWN_AFTER_ONE_OR_MORE_RESTORATIVE_CIRCLE,
    ],
    defaultDisposition: dis2.CR_RPC_OPEN_PENDING,
    paymentIn: [SESSION_FEE, OTHER_FEE],
    paymentOut: [OTHER_FEE, MEDIATOR_PAYMENT, FC_KEEPER_PAYMENT],
};

export const DELIBERATIVE_DIALOGUES = {
    _id: new Types.ObjectId(ACTIVITY_SUBTYPE_DELIBERATIVE_DIALOGUES_ID),
    label: ACTIVITY_SUBTYPE_DELIBERATIVE_DIALOGUES,
    defaultDisposition: dis2.CR_DD_OPEN_PENDING,
    dispositions: [
        //
        dis2.CR_DD_OPEN_PENDING,
        dis2.CR_DD_COMPLETED,
        dis2.CR_DD_WITHDRAWN,
    ],
    paymentIn: [SESSION_FEE, OTHER_FEE],
    paymentOut: [OTHER_FEE, MEDIATOR_PAYMENT, FC_KEEPER_PAYMENT],
};

export const OTHER = {
    _id: new Types.ObjectId(ACTIVITY_SUBTYPE_OTHER_ID),
    label: 'Other',
    defaultDisposition: dis2.CR_OTH_OPEN_PENDING,
    dispositions: [
        //
        dis2.CR_OTH_OPEN_PENDING,
        dis2.CR_OTH_COMPLETED,
        dis2.CR_OTH_WITHDRAWN,
    ],
    paymentIn: [SESSION_FEE, OTHER_FEE],
    paymentOut: [OTHER_FEE, MEDIATOR_PAYMENT, FC_KEEPER_PAYMENT],
};

export const CONFLICT_RESOLUTION = {
    _id: new Types.ObjectId(ACTIVITY_TYPE_CONFLICT_RESOLUTION_ID),
    icon: 'conflictResolution',
    label: ACTIVITY_TYPE_CONFLICT_RESOLUTION,
    description: 'Activities related to conflict resolution processes',
    subTypes: [
        MEDIATION,
        CONCILATION,
        FACILITATION,
        CONFLICT_COACHING,
        RESTORATIVE_PRACTICES,
        DELIBERATIVE_DIALOGUES,
        OTHER,
    ],
};
